import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppMoodTrackerPage } from './app-mood-tracker';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppMoodTrackerPage,
  ],
  imports: [
    IonicPageModule.forChild(AppMoodTrackerPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class AppMoodTrackerPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-mood-tracker/app-mood-tracker.module.ts